// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ActionSelection_buttons__W6ek1","sections":"ActionSelection_sections__2IuyB"};